(function() {
    angular.module('GorillaBoy.services')
    .factory('AuditEmailService', [
        '$routeParams',
        '$http',
        '$log',
        '$q',
        '$rootScope',
        'SessionManager',
        'EndpointService',
        'AppConstants',
        'authenticatedUser',
        AuditEmailService
    ]);

    function AuditEmailService($routeParams, $http, $log, $q, $rootScope, SessionManager, EndpointService, AppConstants, authenticatedUser) {
        // AppConstant bindings
        var httpMethods = AppConstants.HttpMethods;

        var auditEmailService = {};

        var auditEmailServiceRoot = function() {
            return EndpointService.endpoint() + 'organization/audit-email/';
        };

        var userInfo = authenticatedUser.getUserInfo();

        function updateOrganizationAuditEmail(clearVerifiedEmail, clearUnverifiedEmail, unverifiedEmailAddress) {
            var config = {
                url: auditEmailServiceRoot(),
                method: httpMethods.PUT,
                data: {
                    ClearVerifiedEmail: clearVerifiedEmail,
                    ClearUnverifiedEmail: clearUnverifiedEmail,
                    UnverifiedEmailAddress: unverifiedEmailAddress,
                    OrganizationId:  userInfo.OrganizationId,
                }
            };
            return $http(EndpointService.tokenize(config));
        }

        function getOrganizationAuditEmail() {
            var config = {
                url: auditEmailServiceRoot(),
                method: httpMethods.GET,
                params: {
                    OrganizationId:  userInfo.OrganizationId // [&amp;\w+-.@]+
                }
            };
            return $http(EndpointService.tokenize(config));
        }

        function verifyOrganizationAuditEmail(verificationCode) {
            var config = {
                url: auditEmailServiceRoot() + "verification/" + verificationCode,
                method: httpMethods.PUT,
            };
            return $http(EndpointService.tokenize(config));
        }

        function resendOrganizationAuditEmailVerification() {
            var config = {
                url: auditEmailServiceRoot() + "verification/resend",
                method: httpMethods.POST,
                data: {
                    OrganizationId: userInfo.OrganizationId,
                },
            };
            return $http(EndpointService.tokenize(config));
        }

        auditEmailService.addUnverifiedEmail = function(email) {
            return updateOrganizationAuditEmail(false, false, email);
        };

        auditEmailService.getAuditEmails = function() {
            return getOrganizationAuditEmail();
        };

        auditEmailService.removeAuditEmail = function(removeVerified, removeUnverified) {
            return updateOrganizationAuditEmail(removeVerified, removeUnverified, null);
        };

        auditEmailService.resendAuditEmailVerification = function() {
            return resendOrganizationAuditEmailVerification();
        };

        auditEmailService.verifyAuditEmail = function (verificationCode) {
            return verifyOrganizationAuditEmail(verificationCode);
        };

        return auditEmailService;
    }
}());
